import type { SVGProps } from "react";
export interface EyeAltIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EyeAltIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EyeAltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18v-2a1.125 1.125 0 0 1 2.25 0v2c0 1.035.84 1.875 1.875 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 22.125H6A4.125 4.125 0 0 1 1.875 18m18 0v-2a1.125 1.125 0 0 1 2.25 0v2A4.125 4.125 0 0 1 18 22.125h-2a1.125 1.125 0 0 1 0-2.25h2c1.035 0 1.875-.84 1.875-1.875m-18-10V6A4.125 4.125 0 0 1 6 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 4.125H6c-1.036 0-1.875.84-1.875 1.875v2a1.125 1.125 0 0 1-2.25 0m18 0V6c0-1.036-.84-1.875-1.875-1.875h-2a1.125 1.125 0 0 1 0-2.25h2A4.125 4.125 0 0 1 22.125 6v2a1.125 1.125 0 0 1-2.25 0m-7.877-2.125c4.795 0 6.921 4.085 7.451 5.295a2.06 2.06 0 0 1 0 1.66c-.53 1.21-2.656 5.295-7.451 5.295-4.796 0-6.92-4.087-7.449-5.296a2.06 2.06 0 0 1 0-1.657l.275-.574c.827-1.593 2.976-4.723 7.174-4.723m0 2.25c-3.242 0-4.827 2.71-5.353 3.874.525 1.165 2.11 3.876 5.353 3.877s4.829-2.71 5.355-3.877c-.527-1.165-2.114-3.874-5.355-3.874m.877 3.874a.876.876 0 1 0-1.751.003.876.876 0 0 0 1.751-.003m2.25 0a3.126 3.126 0 1 1-6.249 0 3.126 3.126 0 0 1 6.25 0Z"
      />
    </svg>
  );
}
